<template>
  <div>
    <speakol-confirmation-popup
      v-on:hide-confirmation-popup="deletionConfirmationPopup.show = false"
      v-on:confirm="deleteAction(account)"
      :showConfirmationPopup="deletionConfirmationPopup.show"
      :title="deletionConfirmationPopup.title"
      :htmlBody="deletionConfirmationPopup.htmlBody"
      :confirmationText="deletionConfirmationPopup.confirmationText"
    >
      <template v-slot:confirmation v-if="deletionConfirmationPopup.showCampaigns">
        <vs-button
          @click="redirectToCampaigns(account.id)"
          class="w-full mb-4 md:mb-0 md:w-1/3 md:ml-5 md:order-last px-0">
          {{ 'Show Campaigns' }}
        </vs-button>
      </template>
    </speakol-confirmation-popup>

    <speakol-response-popup
      v-on:hide-response-popup="deletionErrorPopup.show = false"
      :responsePopupData="deletionErrorPopup"
    />
  </div>
</template>

<script>
export default {
  props: ['account'],
  data () {
    return {
      deletionConfirmationPopup: {
        show: false,
        title: 'Delete Confirmation',
        htmlBody: ''
      },
      deletionErrorPopup: {
        show: false,
        type: 'error',
        body: ''
      },
      errorPopups: [
        'SUBACCOUNTS',
        'HAS_FUNDS'
      ],
      showCampaignsPopup: [
        'HAS_CAMPAIGNS_NO_INSIGHTS',
        'HAS_CAMPAIGNS_HAS_INSIGHTS'
      ]
    }
  },

  methods: {
    async deleteAccount (accountId) {
      const response = await window.axios.get(`/accounts/${accountId}/can-delete`)

      const responsePayload = response.data.payload

      const deleteMsg = this.setDeleteMessage(responsePayload)

      // If he can delete
      if (responsePayload.can) {
        this.deletionConfirmationPopup.show = true
        this.deletionConfirmationPopup.htmlBody = deleteMsg
      } else if (this.showCampaignsPopup.includes(responsePayload.meta.reason)) {
        this.deletionConfirmationPopup.show = true
        this.deletionConfirmationPopup.htmlBody = deleteMsg
        this.deletionConfirmationPopup.showCampaigns = true
      } else if (this.errorPopups.includes(responsePayload.meta.reason)) {
        this.deletionErrorPopup.show = true
        this.deletionErrorPopup.body = deleteMsg
      }
    },

    async deleteAction (account) {
      await this.$store.dispatch('accounts/deleteAccount', account)

      this.deletionConfirmationPopup.show = false
    },

    setDeleteMessage (responsePayload) {
      const resMeta = responsePayload.meta

      if (resMeta.reason === 'SUBACCOUNTS') {
        return `This account has <strong>${responsePayload.meta.count} Subaccounts</strong>. You must delete these subaccounts first before deleting this account.`
      } else if (resMeta.reason === 'NO_FUND_NO_CAMPAIGNS') {
        return `This account has <strong>NO campaigns</strong> and <strong>NO funds</strong>. Are you sure you want to delete <strong>${this.account.name}</strong>'s account?`
      } else if (resMeta.reason === 'HAS_FUNDS') {
        return `This account has <strong>$${responsePayload.meta.amount}</strong> in funds. It cannot be deleted.`
      } else if (resMeta.reason === 'HAS_CAMPAIGNS_NO_INSIGHTS') {
        return `This account has <strong>${responsePayload.meta.count} campaigns</strong> . You must delete these campaigns before deleting this account.`
      } else if (resMeta.reason === 'HAS_CAMPAIGNS_HAS_INSIGHTS') {
        return `This account has <strong>${responsePayload.meta.count} campaigns with insights.</strong> It can’t be deleted.`
      }
    },

    redirectToCampaigns (accountId) {
      this.deletionConfirmationPopup.show = false

      setTimeout(() => {
        this.$router.push(`/campaigns/admin?account-id=${accountId}`)
      }, 10)
    }
  }
}

</script>

